'use client';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import {NamedFaIcon} from '../icon';
import {Typography} from '../primitives';

export interface FeatureItemProps {
  icon: string;
  title: string;
  subtitle: string;
}

const Root = styled(Box)({display: 'flex', alignItems: 'flex-end', gap: 21});

const IconChip = styled(Box)(({theme}) => ({
  flexShrink: 0,
  width: 48,
  height: 48,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.radii.full,
  backgroundColor: theme.palette.colors.surface.primary.default,
  color: theme.palette.colors.icon.neutral.inverse,
}));

const Texts = styled(Box)(({theme}) => ({display: 'flex', flexDirection: 'column', gap: theme.spacing(0.5), minWidth: 0}));

export function FeatureItem({icon, title, subtitle}: FeatureItemProps) {
  return (
    <Root>
      <IconChip>
        <NamedFaIcon name={icon} fontSize={24} aria-hidden />
      </IconChip>
      <Texts>
        <Typography size="body-1" weight="bold" family="primary" as="h3">
          {title}
        </Typography>
        <Typography size="body-3" weight="regular" as="p" sx={{color: theme => theme.palette.colors.text.neutral.default}}>
          {subtitle}
        </Typography>
      </Texts>
    </Root>
  );
}

FeatureItem.displayName = 'FeatureItem';
